<template>
  <div class="xu-store-info">
    <div class="info">
      <!-- isAllot：0拓展、1维护 -->
      <div class="item-title">{{ $t('form.basicInfo') }}</div>
      <div class="item-info">
        <div class="item-section">
          <span class="left txt-ellipsis">{{ !['salesDistribution'].includes(pageType) ? $t('form.storeID') : $t('form.distributorID') }}</span>
          <span class="right txt-ellipsis" v-if="['salesDistribution'].includes(pageType)">{{ customerInfo.sdCode }}</span>
          <span class="right txt-ellipsis" v-else>{{ customerInfo.customerCode }}</span>
        </div>
        <div v-if="pageType === 'storeMaintain'" class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.storeTag') }}</span>
          <span v-if="!['', null].includes(customerInfo.customerTag)" class="right txt-ellipsis tag-info" :class="customerInfo.customerTag | formatTagClass">{{ customerInfo.customerTag | formatTag }}</span>
        </div>
        <div v-if="['storeMaintain', 'salesDistribution'].includes(pageType)" class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.assignedBaBd') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.dutyName }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.outsidePicture') }}</span>
          <span class="right" v-if="customerInfo.imgUrl">
            <img class="img-icon" :src="customerInfo.imgUrl" alt="" @click.stop="imgPreview(customerInfo.imgUrl)">
          </span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.address') }}</span>
          <span class="right address-txt" @click="getlocation(customerInfo)">{{ customerInfo.address }}</span>
        </div>
        <div class="item-section" v-if="['storeExpansion'].includes(pageType)">
          <span class="left txt-ellipsis">{{ $t('form.storeType') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.customerType }}</span>
        </div>
        <div class="item-section" v-if="['storeExpansion'].includes(pageType)">
          <span class="left txt-ellipsis">{{ $t('form.businessStatus') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.status === 1 ? $t('form.business') : customerInfo.status === -1 ? $t('form.temporarilyClosed') : customerInfo.status === -2 ? $t('form.permanentlyClosed') : customerInfo.status === -3 ? $t('form.invalid') : '' }}</span>
        </div>
        <div class="item-section" v-if="['salesDistribution'].includes(pageType)">
          <span class="left txt-ellipsis">{{ $t('form.distributorTag') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.sdTag === 1 ? $t('form.keyDistributor') : customerInfo.sdTag === 0 ? $t('form.notKeyDistributor') : '' }}</span>
        </div>
        <div class="item-section" v-if="['salesDistribution'].includes(pageType)">
          <span class="left txt-ellipsis">{{ $t('form.distributorType') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.sdType }}</span>
        </div>
        <div class="item-section" v-if="['salesDistribution'].includes(pageType)">
          <span class="left txt-ellipsis">{{ $t('form.businessType') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.businessType }}</span>
        </div>
        <div class="item-section" v-if="!['salesDistribution'].includes(pageType)">
          <span class="left txt-ellipsis">{{ $t('form.chainOrNot') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.isChain ? $t('shared.filter.yes') : $t('shared.filter.no') }}</span>
        </div>
        <div class="item-section" v-if="!['salesDistribution'].includes(pageType) && customerInfo.isChain">
          <span class="left txt-ellipsis">{{ $t('form.numberofChainStores') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.chainCount }}</span>
        </div>
        <div class="item-section" v-if="!['salesDistribution'].includes(pageType) && customerInfo.isChain">
          <span class="left txt-ellipsis">{{ $t('shared.distributor') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.belongSd.sdName }}</span>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="item-title">{{ $t('form.decisionMakerInfo') }}</div>
      <div class="item-info">
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.decisionMakerRole') }}</span>
          <span class="right txt-ellipsis">{{ decisionContact.job }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.decisionMakerName') }}</span>
          <span class="right txt-ellipsis">{{ decisionContact.contactName }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.phoneNumber') }}</span>
          <span class="right txt-ellipsis">{{ decisionContact.phone }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.email') }}</span>
          <span class="right txt-ellipsis">{{ decisionContact.email }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.notes') }}</span>
          <span class="right txt-ellipsis">{{ decisionContact.remark }}</span>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="item-title">{{ $t('form.footTrafficInformation') }}</div>
      <div class="item-info">
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.weekdayFootTraffic') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.weekdayTraffic }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.weekdayPeakTraffic') }}<br />{{ $t('form.timePeriods') }}</span>
          <span class="right">{{ customerInfo.weekdayPeakTrafficTime }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.weekendFootTraffic') }}</span>
          <span class="right txt-ellipsis">{{ customerInfo.weekendTraffic }}</span>
        </div>
        <div class="item-section">
          <span class="left txt-ellipsis">{{ $t('form.weekendPeakTraffic') }}<br />{{ $t('form.timePeriods') }}</span>
          <span class="right">{{ customerInfo.weekendPeakTrafficTime }}</span>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="item-title">{{ ['salesDistribution'].includes(pageType) ? $t('shared.distributor') : $t('shared.store') }} {{ $t('form.customerReach') }}</div>
      <div class="item-info">
        <div class="item-section" v-if="['salesDistribution'].includes(pageType)">
          <span class="left">{{ $t('form.numberOfAffiliatedCoreStore') }}</span>
          <span class="right">{{ customerInfo.coreStoreCount }}</span>
        </div>
        <div class="item-section">
          <span class="left">{{ ['salesDistribution'].includes(pageType) ? $t('form.corePromotedProductBrand') : $t('form.disposableBrandDiversity') }}</span>
          <span class="right" v-show="['salesDistribution'].includes(pageType)">{{ customerInfo.coreBrand }}</span>
          <span class="right" v-show="!['salesDistribution'].includes(pageType)">{{ customerInfo.disposableBrandDiversity }}</span>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="item-title">{{ ['salesDistribution'].includes(pageType) ? $t('shared.distributor') : $t('shared.store') }} {{ $t('form.promotionCapability') }}</div>
      <div class="item-info">
        <div class="item-section">
          <span class="left">{{ $t('form.officialWebsiteAvailable') }}</span>
          <span class="right">{{ customerInfo.isOnlineWeb ? $t('shared.filter.yes') : customerInfo.isOnlineWeb === false ? $t('shared.filter.no') : $t('shared.filter.unknown') }}</span>
        </div>
        <div class="item-section">
          <span class="left">{{ $t('form.whatsAppGroupAvailable') }}</span>
          <span class="right">{{ customerInfo.isWhatsappGroup ? $t('shared.filter.yes') : customerInfo.isWhatsappGroup === false ? $t('shared.filter.no') : $t('shared.filter.unknown') }}</span>
        </div>
        <div class="item-section">
          <span class="left">{{ $t('form.facebookInstagramAvailable') }}</span>
          <span class="right">{{ customerInfo.isIns ? $t('shared.filter.yes') : customerInfo.isIns === false ? $t('shared.filter.no') : $t('shared.filter.unknown') }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="info" v-if="!['salesDistribution'].includes(pageType)">
      <div class="item-title">{{ globalData.brandName }} Retail Price</div>
      <div class="item-info" v-for="productItem in retailList" :key="productItem.productId">
        <div class="item-section">
          <span class="left left-num">{{ productItem.productName }} Retail Price(USD)</span>
          <span class="right right-num">{{ productItem.retailPrice }}</span>
        </div>
      </div>
    </div> -->
    <div class="info" v-if="!['salesDistribution'].includes(pageType) && retailList.length > 0">
      <div class="item-title">{{ globalData.brandName }} {{ $t('form.retailPrice') }}</div>
      <div class="item-info">
        <div class="brand-section" v-for="(brandItem, brandIndex) in retailList" :key="brandIndex">
          <div class="brand-title square" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
            <span class="right-name van-ellipsis">{{ brandItem.projectName }} · {{ subItem.productName }}</span>
            <span><span class="custom-font">{{ subItem.retailPrice }}</span> {{ $t('form.uSD') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="item-title">{{ $t('form.listingStatus') }}</div>
      <div class="item-info">
        <div class="item-section custom-section">
          <van-collapse v-for="shelfItem in localShelfList" :key="`collapse-${shelfItem.projectId}`" v-model="shelfItem.activeNames">
            <van-collapse-item :name="shelfItem.projectId" >
              <template #title>
                <div class="list-label square">
                  {{ shelfItem.projectName }}
                </div>
              </template>
              <van-collapse v-for="proItem in shelfItem.productList" :key="`collapse-${proItem.productId}`" v-model="proItem.activeNames">
                <van-collapse-item :name="proItem.productId" :disabled="proItem.isShelf !== 1">
                  <template #title>
                    <div class="collapse-title">
                      <span>{{ proItem.productName }} {{ $t('form.listed') }}</span>
                      <span>{{ proItem.isShelf == 0 ? $t('form.notListing') : proItem.isShelf == 1 ? $t('form.listing') : proItem.isShelf == -1 ? $t('form.endOfSales') : $t('shared.filter.unknown') }}</span>
                    </div>
                  </template>
                  <div class="status-info" v-for="logItem in proItem.shelfLogList" :key="logItem.id">
                    <div class="status-item" v-if="logItem.shelfType">{{ logItem.shelfType }}</div>
                    <div class="status-val">{{ $t('form.lastest') }}: {{ logItem.lastCreateTime }} <span v-if="logItem.lastSaleCount"><span class="num">{{ logItem.lastSaleCount }}</span> {{ $t('form.pcs') }}</span></div>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
    <div class="info" v-if="!['salesDistribution'].includes(pageType)">
      <div class="item-title title-custom">
        <span class="left-title">{{ $t('form.storeGroup') }}</span>
        <span class="right-group" @click="handleOper('add')" v-if="$route.query.readOnly !== 'true'">+ {{ $t('form.newGroup') }}</span>
      </div>
      <div class="item-info">
        <div class="item-section" v-for="subItem in customerInfo.labelList" :key="subItem.id">
          <span class="left group-name txt-ellipsis">{{ subItem.labelName }}</span>
          <img class="del-img" src="@/assets/images/event_del.png"  alt="" @click="handleOper('del', subItem)">
        </div>
      </div>
      <div class="brand-diversity-tips">
        <div class="tips-item">
          <van-icon name="info-o" size="13" class="info-icon" color="#307bff" />
          <span>{{ $t('tips.messageOne') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { arsLabelDeleteRelevancyApi } from '@/api/storePage'
import { Toast, Dialog, ImagePreview } from 'vant'
import { mapState } from 'vuex'
import i18n from '@/i18n'
export default {
  props: {
    customerInfo: {
      type: Object,
      default: () => {}
    },
    shelfList: {
      type: Array,
      default: () => []
    },
    retailList: {
      type: Array,
      default: () => []
    },
    decisionContact: {
      type: Object,
      default: () => {}
    },
    activeNames: {
      type: Array,
      default: () => []
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  data () {
    return {
      localShelfList: []
    }
  },
  watch: {
    shelfList: {
      immediate: true,
      handler (val) {
        if (val && val.length > 0) {
          this.localShelfList = val.map(item => ({
            ...item,
            activeNames: [item.projectId],
            productList: item.productList.map(proItem => ({
              ...proItem,
              // activeNames: !proItem.shelfLogList ? [] : proItem.shelfLogList.length > 0 ? [proItem.productId] : [],
              activeNames: [],
              shelfLogList: proItem.isShelf === 1 ? proItem.shelfLogList : []
            }))
          }))
        } else {
          this.localShelfList = []
        }
      }
    }
  },
  methods: {
    handleOper (type, params = {}) {
      if (['add', 'edit'].includes(type)) {
        this.$emit('getLabelData')
      } else if (type === 'del') {
        Dialog.confirm({
          message: this.$t('tips.messageTwo'), // 将该门店从当前分组移除（不会直接删除门店）
          confirmButtonText: this.$t('button.delete'),
          cancelButtonText: this.$t('button.cancel'),
          confirmButtonColor: '#d9001b'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            const data = {
              labelId: params.id,
              relevancyIdList: [this.customerInfo.id]
            }
            arsLabelDeleteRelevancyApi(data).then(res => {
              Toast.clear()
              this.$emit('getCustomerInfo')
            })
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    getlocation (params) {
      if (this.$route.query.readOnly === 'true') {
        return
      }
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${params.address}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.xu-store-info {
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .title-custom {
      justify-content: space-between;
      padding-right: 12px;
      &::before {
        display: none;
      }
      .left-title {
        display: flex;
        align-items: center;
        &::before {
          content: '';
          width: 6px;
          height: 12px;
          margin-right: 3px;
          background-color: #307bff;
        }
      }
      .right-group {
        font-weight: 400;
      }
    }
    .item-info {
      padding: 0px 12px;
      .item-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .left {
          width: 148px;
        }
        .right {
          flex: 1;
          text-align: right;
        }
        .group-name {
          flex: 1;
        }
        .del-img {
          width: 17px;
          height: 17px;
        }
        .left-num {
          width: 200px;
        }
        .address-txt {
          color: #307bff;
          text-decoration: underline;
        }
        .tag-info {
          max-width: 86px;
          padding: 3px 5px;
          text-align: center;
          font-size: 10px;
          border: 1px solid #ee541b;
          color: #ee541b;
          background-color: #eccfc4;
        }
        .tag0 {
          border: 1px solid #0db00b;
          color: #0db00b;
          background-color: #abdaaa;
        }
        .tag2 {
          border: 1px solid #dc851f;
          color: #dc851f;
          background-color: #f0e2d1;
        }
        .tag3 {
          border: 1px solid #7f7f7f;
          color: #7f7f7f;
          background-color: #dcdcdc;
        }
      }
      .custom-section {
        display: block;
        padding: 0;
        .list-label {
          display: flex;
          align-items: center;
          padding-left: 1px;
          margin-top: 10px;
          font-weight: bold;
          &.square {
            font-weight: bold;
            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background-color: #307bff;
              // position: absolute;
              // left: 0;
              // top: 0;
              transform: rotate(45deg);
              margin-right: 5px;
            }
          }
        }
        .collapse-title {
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
          font-size: 12px;
          color: #000;
        }
        .status-info {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          font-size: 12px;
          &:last-child {
            margin-bottom: 10px;
          }
          .status-item {
            max-width: 116px;
            padding: 2px;
            border: 1px solid #307bff;
            color: #307bff;
            margin-right: 5px;
            font-size: 10px;
          }
          .status-val {
            flex: 1;
            word-break: break-word;
          }
          .num {
            color: #307bff;
          }
        }
        /deep/.van-collapse {
          border-bottom: 1px solid #e8effc;
          &:last-child {
            border-bottom: none;
          }
          .van-collapse-item {
            border-bottom: 1px solid #e8effc;
            &:last-child {
              border-bottom: none;
            }
          }
          .van-collapse-item__title {
            display: flex;
            align-items: center;
            padding: 2px 0;
          }
          .van-collapse-item__title::after {
            display: none;
          }
          .van-collapse-item--border::after {
            display: none;
          }
          .van-collapse-item__content {
            padding: 0px 0;
            color: #000;
          }
          .custom-collapse {
            .van-collapse-item__content {
              display: none;
            }
          }
          .van-collapse-item__title--disabled {
            .van-icon {
              display: none;
            }
          }
        }
        /deep/.van-hairline--top-bottom::after {
          border: none;
        }
      }
      .img-icon {
        width: 60px;
        height: 60px;
      }
      .brand-section {
        .brand-title {
          display: flex;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #e8effc;
          .right-name {
            flex: 1;
            font-weight: bold;
          }
          color: #333;
          &.square {
            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background-color: #307bff;
              transform: rotate(45deg);
              margin-right: 5px;
            }
          }
        }
      }
      .custom-font {
        font-weight: bold;
        color: #307bff;
      }
    }
    .brand-diversity-tips {
      margin-top: 10px;
      color: #307bff;
      font-size: 11px;
      padding: 0 10px;
      .tips-item {
        display: flex;
        align-items: center;
        .info-icon {
          margin-right: 3px;
        }
      }
    }
  }
}
</style>
